import React, { Component, Fragment } from 'react'
import {
    Button,
    Modal, ModalBody, ModalFooter,
    ModalHeader
} from 'reactstrap'
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import * as categories from 'catalog/actions/categories'

@connect(
    null,
    dispatch => ({
        remove: category => dispatch(categories.remove(category))
    })
)
export default class DeleteCategory extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isOpen: false
        }
    }

    @autobind
    toggle() {
        const isOpen = !this.state.isOpen
        this.setState({ isOpen })
    }

    @autobind
    confirm() {
        const {remove, category} = this.props
        remove(category)
        this.toggle()
    }

    render() {
        const {
            isOpen
        } = this.state
        return (
            <Fragment>
                <Button color='danger' title='Kategorie löschen'
                    onClick={this.toggle}>
                    <i className='fa fa-trash'> </i>
                </Button>
                <Modal isOpen={isOpen}>
                    <ModalHeader>
                        Kategorie löschen
                                </ModalHeader>
                    <ModalBody>
                        Sind Sie sicher, dass Sie die Kategorie löschen möchten?
                                </ModalBody>
                    <ModalFooter>
                        <Button color='danger'
                            onClick={this.confirm}>Bestätigen</Button>
                        <Button color='default'
                            onClick={this.toggle}>Abbrechen</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        )
    }
}